export default __webpack_public_path__ + "static/media/rambouillet05.ceabe628.jpg";